import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, Pipe, Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i3 from '@am/experts-tools-control';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

class AmExpertsCompensationService {
    constructor(http) {
        this.http = http;
        this.url = '/experts/compensations/api/compensation';
    }
    getCompensation(queryParams) {
        return this.http.get(this.url, { params: queryParams });
    }
    getCompensationBooking(queryParams) {
        return this.http.get(`${this.url}/booking`, {
            params: queryParams,
        });
    }
    formatCompensation(compensation) {
        if (!compensation) {
            return null;
        }
        return Math.max(0, Math.round(compensation.amount));
    }
}
/** @nocollapse */ AmExpertsCompensationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AmExpertsCompensationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class CompensationQueryParams {
}
class Compensation {
}
const BRAZIL_COMMISSION = {
    FLIGHT: '3%',
    INSURANCE: '25%',
};
const DEFAULT_COMISSION = '8%';

const SPANISH_TRANSLATION = {
    'commissionaprox': 'Código',
    'commission': 'Código',
    'markup': 'Margen',
    'error': 'Error de cálculo',
    'comission': 'Código'
};
const PORTUGUESE_TRANSLATION = {
    'commissionaprox': 'Code',
    'commission': 'Code',
    'markup': 'Margen',
    'error': 'Erro de cálculo',
    'comission': 'Code'
};
const translation = {
    'es-AR': SPANISH_TRANSLATION,
    'es-CO': SPANISH_TRANSLATION,
    'es-MX': SPANISH_TRANSLATION,
    'pt-BR': PORTUGUESE_TRANSLATION,
};
const siteXLocale = {
    'ARG': 'es-AR',
    'BRA': 'pt-BR',
    'COL': 'es-CO',
    'MEX': 'es-MX',
};
const BRAZIL_SITE = 'BRA';
const BRAZIl_DOMAIN = 'br';
const DEFAULT_LOCALE = 'es-AR';
const DEFAULT_SITE = 'ARG';

class TranslationService {
    constructor() { }
    getTranslation(locale) {
        return translation[locale] || translation[DEFAULT_LOCALE];
    }
    getTranslationFromSite(site) {
        return translation[siteXLocale[site]] || translation[DEFAULT_LOCALE];
    }
    transformCurrency(currency) {
        if (!currency) {
            return currency;
        }
        const values = {
            'R$': 'BRL'
        };
        return values[currency.toUpperCase()] || currency;
    }
    isBrazilSite(site) {
        if (site && site.toUpperCase() === BRAZIL_SITE) {
            return true;
        }
        else if (site) {
            return false;
        }
        return window.location.hostname.endsWith(BRAZIl_DOMAIN);
    }
}
/** @nocollapse */ TranslationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ TranslationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TranslationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class AmformatPricePipe {
    transform(value) {
        return value.toLocaleString();
    }
}
/** @nocollapse */ AmformatPricePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmformatPricePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ AmformatPricePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmformatPricePipe, name: "formatPrice" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmformatPricePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'formatPrice' }]
        }] });

class AmExpertsCompensationComponent {
    constructor(compensationService, translationService, expertsTools, changeDetectorRef) {
        this.compensationService = compensationService;
        this.translationService = translationService;
        this.expertsTools = expertsTools;
        this.changeDetectorRef = changeDetectorRef;
        this.expertsTools.visibleTools.subscribe((visibility) => {
            this.expertsToolsActive = visibility;
        });
    }
    ngOnInit() {
        if (this.locale) {
            this.translation = this.translationService.getTranslation(this.locale);
        }
        else if (this.site) {
            this.translation = this.translationService.getTranslationFromSite(this.site);
        }
        else {
            this.translation = this.translationService.getTranslation(this.locale);
        }
    }
    ngOnChanges(changes) {
        this.loading = true;
        this.rule = null;
        this.compensation = 0;
        this.hasMargin = true;
        if (this.displayCompensation) {
            this.hasPermission = true;
            this.isFreelancer = false;
            this._checkPermission();
            this._getCompensation();
        }
    }
    _getCompensation() {
        if (this._getErrorInParameters()) {
            this.loading = false;
            this.error = true;
            console.error('[am-experts-compensation] Invalid argument. We expect availabilityId, or margin & currency.', {
                availabilityId: this.availabilityId,
                productReservationId: this.productReservationId,
                margin: this.margin,
                currency: this.currency,
                error: this._getErrorInParameters(),
            });
            return;
        }
        if (this.currency !== this.translationService.transformCurrency(this.currency)) {
            console.warn('[am-experts-compensation] [deprecated] Invalid argument. We expect an ISO code for currency.', 'Use ' +
                this.translationService.transformCurrency(this.currency) +
                ' instead of ' +
                this.currency +
                '.');
        }
        const params = this._generateQueryParams();
        if (this.translationService.isBrazilSite(this.site) && this.isFreelancer) {
            this.compensation =
                BRAZIL_COMMISSION[params.productType] || DEFAULT_COMISSION;
            this.loading = false;
            this.hasMargin = true;
            this.error = false;
        }
        else if (this.compensationValue) {
            const parseCompensation = Number(this.compensationValue);
            if (isNaN(parseCompensation)) {
                this._onGetCompensationError();
            }
            else {
                this._onGetCompensationNext({
                    amount: parseCompensation,
                    currency: this.currency,
                });
            }
        }
        else if (this.productReservationId) {
            params.productId = encodeURIComponent(this.productReservationId);
            if (this.currency) {
                params.currencyCode = this.translationService.transformCurrency(this.currency);
            }
            this.compensationService
                .getCompensationBooking(params)
                .subscribe({
                next: (compensation) => {
                    this._onGetCompensationNext(compensation);
                },
                error: () => {
                    this._onGetCompensationError();
                },
            })
                .add(() => this.changeDetectorRef.detectChanges());
        }
        else {
            if (this.margin !== undefined && this.margin !== null) {
                params.markup = this.margin;
            }
            else {
                params.availabilityId = encodeURIComponent(this.availabilityId);
            }
            if (this.currency) {
                params.currencyCode = this.translationService.transformCurrency(this.currency);
            }
            this.compensationService
                .getCompensation(params)
                .subscribe({
                next: (compensation) => {
                    this._onGetCompensationNext(compensation);
                },
                error: () => {
                    this._onGetCompensationError();
                },
            })
                .add(() => this.changeDetectorRef.detectChanges());
        }
    }
    _getErrorInParameters() {
        const hasNoMargin = this.margin === undefined || this.margin === null;
        if (hasNoMargin && this.availabilityId) {
            return false;
        }
        if (hasNoMargin && this.productReservationId) {
            return false;
        }
        if (hasNoMargin) {
            return 'Margin is ' + this.margin + '. Expected: Number';
        }
        if (!this.currency) {
            return ('Currency is ' + this.currency + '. Expected: String(Currency ISO code)');
        }
        if (!this.translationService.transformCurrency(this.currency)) {
            return 'Currency is not valid. Recieved' + this.currency + '.';
        }
        return false;
    }
    get isBrazil() {
        return this.translationService.isBrazilSite(this.site);
    }
    _checkPermission() {
        if (amLoginGuard.hasPermission('experts', 'expert-commission')) {
            this.isFreelancer = true;
        }
        else if (!amLoginGuard.hasPermission('experts', 'expert-margin')) {
            this.hasMargin = false;
            this.hasPermission = false;
        }
    }
    _generateQueryParams() {
        const params = {
            channel: this.channel,
            site: this.site,
            productType: this.productType,
            brand: this.brand,
            language: this.language,
        };
        if (this.ratio) {
            params.ratio = this.ratio;
        }
        return params;
    }
    _onGetCompensationNext(compensation) {
        this.rule = compensation;
        this.compensation = this.compensationService.formatCompensation(compensation);
        if (this.compensation === null) {
            this.hasMargin = false;
        }
        this.loading = false;
        this.hasMargin = true;
        this.error = false;
    }
    _onGetCompensationError() {
        this.loading = false;
        this.error = true;
    }
    get userIsLogged() {
        return amLoginGuard.isLogged();
    }
    get displayCompensation() {
        return (this.userIsLogged &&
            this._isExpertsSubdomain() &&
            this._hasExpertPermission());
    }
    _isExpertsSubdomain() {
        const hostname = location.hostname;
        return (hostname.includes('ccr') ||
            hostname.includes('experts') ||
            hostname.includes('sucursales') ||
            hostname.includes('viagens') ||
            hostname.includes('localhost'));
    }
    _hasExpertPermission() {
        return (amLoginGuard.hasPermission('experts', 'expert-commission') ||
            amLoginGuard.hasPermission('experts', 'expert-margin'));
    }
}
/** @nocollapse */ AmExpertsCompensationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationComponent, deps: [{ token: AmExpertsCompensationService }, { token: TranslationService }, { token: i3.AmExpertsToolsControlService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AmExpertsCompensationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: AmExpertsCompensationComponent, selector: "am-experts-compensation", inputs: { availabilityId: "availabilityId", brand: "brand", channel: "channel", currency: "currency", language: "language", locale: "locale", margin: "margin", productType: "productType", ratio: "ratio", site: "site", compensationValue: "compensationValue", productReservationId: "productReservationId" }, providers: [AmExpertsCompensationService, TranslationService], usesOnChanges: true, ngImport: i0, template: "<div class=\"am-experts-compensation\" *ngIf=\"displayCompensation && expertsToolsActive\">\n\n  <div class=\"description\" *ngIf=\"hasMargin && isFreelancer && !error && !isBrazil\">\n    <span i18n=\"Approximately the commision@@commissionAprox\">C\u00F3digo.</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasMargin && !isFreelancer && hasPermission && !error\">\n    <span i18n=\"The commission@@commission\">C\u00F3digo</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasMargin && isFreelancer && hasPermission && !error && isBrazil\">\n    <span i18n=\"The commission@@commission\">C\u00F3digo</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasPermission && error\" i18n=\"Error on calculating the commission@@error\">\n    Error de calculo\n  </div>\n\n</div>\n", styles: [".am-experts-compensation{text-align:center;background-color:var(--color-error-clear);position:relative;transition:all 2s;-webkit-transition:all 2s;opacity:1;border-radius:4px}.am-experts-compensation .description{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:2;color:var(--color-error-dark);margin:0;padding:0}.am-experts-compensation .description .compensation{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:2}.am-experts-compensation.ng-hide{opacity:0}\n"], dependencies: [{ kind: "directive", type: i4.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: AmformatPricePipe, name: "formatPrice" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-experts-compensation', providers: [AmExpertsCompensationService, TranslationService], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"am-experts-compensation\" *ngIf=\"displayCompensation && expertsToolsActive\">\n\n  <div class=\"description\" *ngIf=\"hasMargin && isFreelancer && !error && !isBrazil\">\n    <span i18n=\"Approximately the commision@@commissionAprox\">C\u00F3digo.</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasMargin && !isFreelancer && hasPermission && !error\">\n    <span i18n=\"The commission@@commission\">C\u00F3digo</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasMargin && isFreelancer && hasPermission && !error && isBrazil\">\n    <span i18n=\"The commission@@commission\">C\u00F3digo</span>\n    <span class=\"compensation\"> {{compensation | formatPrice}}</span>\n  </div>\n\n  <div class=\"description\" *ngIf=\"hasPermission && error\" i18n=\"Error on calculating the commission@@error\">\n    Error de calculo\n  </div>\n\n</div>\n", styles: [".am-experts-compensation{text-align:center;background-color:var(--color-error-clear);position:relative;transition:all 2s;-webkit-transition:all 2s;opacity:1;border-radius:4px}.am-experts-compensation .description{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:2;color:var(--color-error-dark);margin:0;padding:0}.am-experts-compensation .description .compensation{font-size:.875rem;font-weight:var(--font-weight-semibold);line-height:2}.am-experts-compensation.ng-hide{opacity:0}\n"] }]
        }], ctorParameters: function () { return [{ type: AmExpertsCompensationService }, { type: TranslationService }, { type: i3.AmExpertsToolsControlService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { availabilityId: [{
                type: Input
            }], brand: [{
                type: Input
            }], channel: [{
                type: Input
            }], currency: [{
                type: Input
            }], language: [{
                type: Input
            }], locale: [{
                type: Input
            }], margin: [{
                type: Input
            }], productType: [{
                type: Input
            }], ratio: [{
                type: Input
            }], site: [{
                type: Input
            }], compensationValue: [{
                type: Input
            }], productReservationId: [{
                type: Input
            }] } });

class AmExpertsCompensationModule {
    constructor() { }
}
/** @nocollapse */ AmExpertsCompensationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AmExpertsCompensationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationModule, declarations: [AmExpertsCompensationComponent, AmformatPricePipe], imports: [CommonModule, FormsModule, HttpClientModule], exports: [AmExpertsCompensationComponent] });
/** @nocollapse */ AmExpertsCompensationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationModule, imports: [CommonModule, FormsModule, HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AmExpertsCompensationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AmExpertsCompensationComponent, AmformatPricePipe],
                    exports: [AmExpertsCompensationComponent],
                    imports: [CommonModule, FormsModule, HttpClientModule]
                }]
        }], ctorParameters: function () { return []; } });

/*
 * Public API Surface of am-experts-compensation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AmExpertsCompensationComponent, AmExpertsCompensationModule, AmExpertsCompensationService };
